import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ActionBar, Modal, Text } from '@beef/ui-kit';
import { emptyObj } from '@beef/utils';
import { Picture } from "../../../../../../Picture";
import { ActionButton } from "../RenderRequestForm/ActionButton";
import { RenderRequestForm } from "../RenderRequestForm";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var FORM_ID = 'callback-form-modal';
export var RenderPopup = function RenderPopup(_ref) {
  var _data$texts;
  var data = _ref.data,
    isOpen = _ref.isOpen,
    isLoading = _ref.isLoading,
    onClose = _ref.onClose;
  var texts = (data === null || data === void 0 || (_data$texts = data.texts) === null || _data$texts === void 0 ? void 0 : _data$texts.redesignPopupTexts) || emptyObj;
  return /*#__PURE__*/React.createElement(Modal, {
    actionBar: /*#__PURE__*/React.createElement(ActionBar, {
      isLoading: isLoading,
      isWithText: true,
      size: "s"
    }, /*#__PURE__*/React.createElement(ActionButton, {
      agreementText: texts.userAgreementText,
      buttonText: texts.backCallBtnText,
      formId: FORM_ID,
      isLoading: isLoading,
      tooltipText: texts.termsOfUse,
      "data-t-id": "components-RenderPopup"
    })),
    isLoading: isLoading,
    isOpen: isOpen,
    onClose: onClose,
    size: "m",
    "data-t-id": "components-RenderPopup"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, texts.imgUrl && /*#__PURE__*/React.createElement("div", {
    className: cx('main-popup__picture')
  }, /*#__PURE__*/React.createElement(Picture, {
    src: texts.imgUrl
  })), texts.title && /*#__PURE__*/React.createElement(Text, {
    className: cx('main-popup__title'),
    color: "grey95",
    size: "size3-m"
  }, texts.title), /*#__PURE__*/React.createElement(Text, {
    className: cx('main-popup__description'),
    color: "grey50",
    size: "size5-r-s"
  }, texts.backCallTabSubTitle), /*#__PURE__*/React.createElement(RenderRequestForm, {
    data: data,
    formId: FORM_ID
  })));
};
RenderPopup.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.shape({
    texts: PropTypes.shape({
      redesignPopupTexts: PropTypes.shape({
        title: PropTypes.string,
        backCallTabTitle: PropTypes.string,
        backCallTabSubTitle: PropTypes.string,
        techSupportTabTitle: PropTypes.string,
        techSupportTabSubTitle: PropTypes.string
      })
    })
  }),
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
} : {};